import { Link } from 'react-router-dom';

const LOGO_URL =
  'https://public.readdy.ai/ai/img_res/3a363d0d-11f9-42b3-a7ca-99ff2f1cc775.png';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Contact', href: '/contact' },
  { label: 'Book a Consultation', href: '/consultation' },
];

const serviceLinks = [
  { label: 'Lawn Mower Repair', href: '/services/lawn-mower' },
  { label: 'Snow Blower Repair', href: '/services/snow-blower' },
  { label: 'Generator Repair', href: '/services/generator' },
];

const certs = [
  'Briggs & Stratton Master Certified',
  'Stihl Silver Level Certified',
  'Kohler Certified',
  'Kawasaki Certified',
];

export default function Footer() {
  return (
    <footer className="bg-neutral-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src={LOGO_URL}
              alt="Road Tech Services"
              className="h-11 w-auto mb-5 brightness-0 invert"
            />
            <p className="text-neutral-400 text-sm leading-relaxed max-w-sm mb-7">
              Michigan&apos;s certified mobile equipment repair service. We come
              to your home — no hauling, no hassle. Lawn mowers, snow blowers,
              and generators serviced on-site by a Master Certified technician.
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="tel:248-781-0600"
                className="flex items-center gap-3 text-neutral-300 hover:text-orange-400 transition-colors text-sm group cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-neutral-800 group-hover:bg-orange-600 rounded-lg transition-colors">
                  <i className="ri-phone-line text-sm" />
                </div>
                (248) 781-0600
              </a>
              <a
                href="mailto:Road.tech7@gmail.com"
                className="flex items-center gap-3 text-neutral-300 hover:text-orange-400 transition-colors text-sm group cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-neutral-800 group-hover:bg-orange-600 rounded-lg transition-colors">
                  <i className="ri-mail-line text-sm" />
                </div>
                Road.tech7@gmail.com
              </a>
              <div className="flex items-center gap-3 text-neutral-400 text-sm">
                <div className="w-8 h-8 flex items-center justify-center bg-neutral-800 rounded-lg">
                  <i className="ri-map-pin-line text-sm" />
                </div>
                Michigan, United States
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-white mb-5 text-xs uppercase tracking-widest">
              Navigation
            </h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-neutral-400 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-white mb-5 text-xs uppercase tracking-widest">
              Services
            </h3>
            <ul className="space-y-3 mb-8">
              {serviceLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-neutral-400 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="p-4 bg-orange-600/10 border border-orange-600/20 rounded-xl">
              <p className="text-orange-400 text-xs font-semibold uppercase tracking-wider mb-1">
                Live Troubleshooting Call
              </p>
              <p className="text-neutral-300 text-xs leading-relaxed mb-3">
                Stuck on a diagnosis? Book a 1-on-1 call with Matt.
              </p>
              <Link
                to="/consultation"
                className="text-orange-400 hover:text-orange-300 text-xs font-semibold transition-colors cursor-pointer"
              >
                Learn More →
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-neutral-800 mt-14 pt-8 flex flex-col lg:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            © 2025 Road Tech Services. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-3 justify-center items-center">
            {certs.map((cert, i) => (
              <span key={cert} className="flex items-center gap-3">
                <span className="text-neutral-600 text-xs">{cert}</span>
                {i < certs.length - 1 && (
                  <span className="text-neutral-700 text-xs">·</span>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
